import { userManager } from '@app/features/oidc/oidc.config';

// The current access token, or null when there is none, it has expired, or the stored
// user cannot be read. A null sends the request without a token and the 401 handler signs in.
const getAuthToken = async (): Promise<string | null> => {
  try {
    const user = await userManager.getUser();
    return user && !user.expired ? user.access_token : null;
  } catch {
    return null;
  }
};

// Throws on a malformed token rather than returning null: the caller already sits in a
// try/catch that reports to Sentry, and the underlying error (which character failed to
// decode, which key was missing) is the only part worth reading in that report.
function parseJwt<T>(token: string): T {
  const base64Url = token.split('.')[1];
  if (!base64Url) throw new Error('JWT has no payload segment');

  // The payload is base64url and UTF-8. atob() rejects '-' and '_' outright, so swap them
  // back to the standard alphabet first, then undo atob()'s latin1 reading of the bytes.
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join('')
  );

  return JSON.parse(jsonPayload) as T;
}

export { getAuthToken, parseJwt };
